import { MutationTree } from 'vuex'
import State from './types'

export const mutations: MutationTree<State> = {
  setReloadTree(state, { value }: { value: boolean }) {
    state.reloadTree = value
  },
  setTreeLoading(state, { value }: { value: boolean }) {
    state.treeLoading = value
  },
}
